module.exports = {
  buildVersion: "0.8.793",
  buildDate: 1791815945007,
}